import React, { useState } from "react";
import { Link, useLocation } from "react-router";
import { Sidebar } from "../ui";
import { 
    User, 
    LogOut, 
    UserCircle, 
    LayoutDashboard, 
    Trophy, 
    Wallet, 
    Search, 
    Shield,
    ShoppingBag 
} from "lucide-react";

function NavBar() {
    const location = useLocation();
    const [visibleRight, setVisibleRight] = useState(false);
    const logo = (
        <img
            src={require('../../statics/img/escudo-verde.png')}
            alt="logo"
            className="h-7 md:h-8 w-auto object-contain mr-2 transition-all"
        />
    );

    const tipoUserLogado = String(sessionStorage.getItem('brv-tipo-user') || '').toLowerCase();
    const userName = sessionStorage.getItem('brv-user') || 'Usuário';

    let items = [];
    if (tipoUserLogado.includes('staff')) {
        items = [
            {
                label: 'Painel Staff',
                icon: Shield,
                url: '/staff-dashboard',
            },
            {
                label: 'Admin Loja',
                icon: Shield,
                url: '/loja/admin',
            },
            {
                label: 'Loja URB',
                icon: ShoppingBag,
                url: '/loja',
            },
        ];
    } else if (sessionStorage.getItem('brv-tipo-user') === 'Organizador') {
        items = [
            {
                label: 'Dashboard',
                icon: LayoutDashboard,
                url: '/dashboard',
            },
            {
                label: 'Eventos',
                icon: Trophy,
                url: '/eventos',
            },
            {
                label: 'Financeiro',
                icon: Wallet,
                url: '/financeiro',
            },
            {
                label: 'Loja URB',
                icon: ShoppingBag,
                url: '/loja',
            },
        ];
    } else if (sessionStorage.getItem('brv-tipo-user') === 'Corredor') {
        items = [
            {
                label: 'Minhas Corridas',
                icon: Trophy,
                url: '/minhas-corridas',
            },
            {
                label: 'Novas Corridas',
                icon: Search,
                url: '/novas-corridas',
            },
            {
                label: 'Loja URB',
                icon: ShoppingBag,
                url: '/loja',
            },
        ];
    } else {
        items = [
            {
                label: 'Eventos',
                icon: Trophy,
                url: '/',
            },
            {
                label: 'Loja URB',
                icon: ShoppingBag,
                url: '/loja',
            },
        ];
    }

    function handleLogout() {
        sessionStorage.removeItem('brv-user-token');
        sessionStorage.removeItem('brv-user');
        sessionStorage.removeItem('brv-user-id');
        sessionStorage.removeItem('brv-tipo-user');
        sessionStorage.removeItem('brv-id-inscricao');
        window.location.replace('/');
    }

    return (
        <header className="sticky top-0 z-40 w-full bg-urb-dark/85 backdrop-blur-md border-b border-urb-border">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                {/* Logo & Desktop Nav */}
                <div className="flex items-center gap-8">
                    <Link to="/" className="flex items-center">
                        {logo}
                    </Link>

                    <nav className="hidden md:flex items-center gap-1">
                        {items.map((item, idx) => {
                            const IconComponent = item.icon;
                            const isActive = location.pathname === item.url;
                            return (
                                <Link
                                    key={idx}
                                    to={item.url}
                                    className={`flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium transition-all ${
                                        isActive
                                            ? "text-urb-primary bg-urb-primary/10"
                                            : "text-urb-text-secondary hover:text-white hover:bg-white/5"
                                    }`}
                                >
                                    <IconComponent className="w-4 h-4" />
                                    <span>{item.label}</span>
                                </Link>
                            );
                        })}
                    </nav>
                </div>

                {/* Right: User Profile trigger */}
                <div className="flex items-center gap-3">
                    <button
                        type="button"
                        onClick={() => setVisibleRight(true)}
                        className="w-10 h-10 rounded-full bg-urb-card-light border border-urb-border flex items-center justify-center text-urb-primary hover:border-urb-primary hover:bg-urb-primary/10 transition-colors cursor-pointer"
                        aria-label="Perfil do usuário"
                    >
                        <User className="w-5 h-5" />
                    </button>
                </div>
            </div>

            {/* User Sidebar Drawer */}
            <Sidebar
                visible={visibleRight}
                position="right"
                onHide={() => setVisibleRight(false)}
            >
                <div className="flex flex-col h-full">
                    {/* Header */}
                    <div className="flex items-center gap-3 pb-6 border-b border-urb-border pr-8">
                        <div className="w-12 h-12 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center text-urb-primary shrink-0">
                            <User className="w-6 h-6" />
                        </div>
                        <div className="overflow-hidden">
                            <h3 className="font-bold text-white text-base m-0 truncate">{userName}</h3>
                            <span className="text-xs text-urb-primary font-medium block truncate">
                                {sessionStorage.getItem('brv-tipo-user') || 'Usuário'}
                            </span>
                        </div>
                    </div>

                    {/* Menu items */}
                    <div className="flex flex-col gap-2 mt-6 flex-1">
                        <Link
                            to="/perfil"
                            onClick={() => setVisibleRight(false)}
                            className="flex items-center gap-3 px-4 py-3 rounded-xl text-urb-text hover:text-white hover:bg-urb-card-light transition-colors text-sm font-medium"
                        >
                            <UserCircle className="w-5 h-5 text-urb-text-muted" />
                            <span>Meu Perfil</span>
                        </Link>
                        <button
                            type="button"
                            onClick={handleLogout}
                            className="flex items-center gap-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-500/10 transition-colors text-sm font-medium text-left border-none bg-transparent cursor-pointer w-full"
                        >
                            <LogOut className="w-5 h-5" />
                            <span>Sair</span>
                        </button>
                    </div>
                </div>
            </Sidebar>

            {/* Mobile Bottom Navigation */}
            <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-urb-card border-t border-urb-border px-4 py-2 flex items-center justify-around shadow-2xl">
                {items.map((item, idx) => {
                    const IconComponent = item.icon;
                    const isActive = location.pathname === item.url;
                    return (
                        <Link
                            key={idx}
                            to={item.url}
                            className={`flex flex-col items-center gap-1 py-1 px-3 text-xs font-medium transition-colors ${
                                isActive ? "text-urb-primary" : "text-urb-text-muted hover:text-urb-text"
                            }`}
                        >
                            <IconComponent className="w-5 h-5" />
                            <span>{item.label}</span>
                        </Link>
                    );
                })}
                <button
                    type="button"
                    onClick={() => setVisibleRight(true)}
                    className="flex flex-col items-center gap-1 py-1 px-3 text-xs font-medium transition-colors bg-transparent border-none text-urb-text-muted hover:text-urb-text cursor-pointer"
                >
                    <User className="w-5 h-5" />
                    <span>Perfil</span>
                </button>
            </div>
        </header>
    );
}

export default NavBar;